import axios from 'axios'
import config from 'config'

const host = config.apiHost

export const apiCall = () => axios.get(`${host}`)
